import { forwardRef, type SVGProps } from 'react';

export const NoteErrorIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function NoteErrorIcon(props, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          clipRule="evenodd"
          d="M4.587 21.412C4.979 21.804 5.45 22 6 22H18C18.5493 22.0007 19.02 21.805 19.412 21.413C19.804 21.021 20 20.55 20 20V8L14 2H6C5.45067 1.99934 4.98 2.195 4.588 2.587C4.196 2.979 4 3.45 4 4V20C3.99933 20.5493 4.195 21.02 4.587 21.412ZM18 9H13V4L18 9ZM9.57275 12C9.42085 12 9.27516 12.0603 9.16773 12.1677C9.06033 12.2752 9 12.4208 9 12.5728C9 12.7247 9.06033 12.8703 9.16773 12.9778L11.1934 15.0035L9.16773 17.0291C9.06338 17.1372 9.00563 17.2819 9.00694 17.4321C9.00824 17.5823 9.06849 17.726 9.17471 17.8322C9.28092 17.9384 9.42461 17.9987 9.57481 18C9.72502 18.0013 9.86973 17.9435 9.97777 17.8392L12.0035 15.8135L14.0291 17.8392C14.1372 17.9435 14.2819 18.0013 14.4321 18C14.5823 17.9987 14.726 17.9384 14.8322 17.8322C14.9384 17.726 14.9987 17.5823 15 17.4321C15.0013 17.2819 14.9435 17.1372 14.8392 17.0291L12.8135 15.0035L14.8392 12.9778C14.9435 12.8697 15.0013 12.725 15 12.5748C14.9987 12.4246 14.9384 12.2809 14.8322 12.1747C14.726 12.0685 14.5823 12.0082 14.4321 12.0069C14.2819 12.0056 14.1372 12.0634 14.0291 12.1677L12.0035 14.1934L9.97777 12.1677C9.87034 12.0603 9.72466 12 9.57275 12Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    );
  },
);
